import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { User } from './core/models/user';
import { AuthService } from './core/services/auth.service';
import { JWTService } from './core/services/jwt.service';
import { SessionStorageService } from './core/services/session-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { of, Subscription } from 'rxjs';
import { NotificationService } from './core/services/notification.service';
import { LoaderComponent } from './core/components/loader/loader.component';
import { LoaderService } from './core/services/loader.service';
import { NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl:  './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  loading = false;

  title = 'Engine Pricing Tool';
  showHeader = true;
  showNavbar = false;
  headerText = '';
  currentUser: User | null = null;
  tokenSubscription = new Subscription();

  @ViewChild(HeaderComponent)
  child!: HeaderComponent;
  exp: any;
  lastPing: Date | undefined;

  constructor(
    private router: Router,
    private localService: SessionStorageService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private jwt: JWTService,
    public dialog: MatDialog,
    protected _notificationSvc: NotificationService,
    public loaderService: LoaderService,
  ) {
    this.authService.currentUser.subscribe((user) => {
      if (user && user.accessToken) {
        const UserDetails: any = jwt.getDecodedToken();
        this.currentUser = UserDetails;
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true; // Start loading
      } else if (event instanceof NavigationEnd) {
        this.loading = false; // Stop loading
      }
      // You can handle NavigationCancel and NavigationError to stop loading as well
    });
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.authService.loadLocaluser();
    this.router.events.subscribe((event) => {
      this.showNavbar =
        this.activatedRoute.firstChild?.snapshot.data.showNavbar == true;
      if (location.pathname.includes('/ebu/parts/'))
        this.headerText = 'EBU SCORECARD';
      // else if (location.pathname.includes('/distribution/cssna/')) {
      //   this.headerText = 'CSSNA SCORECARD';
      // }
      else if (location.pathname.includes('/distribution/dbu_overall')) {
        this.headerText = 'DBU SCORECARD';
      } else if (location.pathname.includes('/distribution/cssna/')) {
        this.headerText = 'CSSNA SCORECARD';
      } else if (location.pathname.includes('/distribution/international/')) {
        this.headerText = 'INTERNATIONAL';
      }
      else if (location.pathname.includes('/components/ctt/')) {
        this.headerText = 'CTT SCORECARD';
      }
      else if (location.pathname.includes('/power-systems/parts/')) {
        this.headerText = 'PSBU SCORECARD';
      }
       else {
        this.headerText =
          this.activatedRoute.firstChild?.snapshot.data.headerText;
      }

      if (window.location.pathname == '/logout') {
        this.currentUser = null;
      }
      if (
        window.location.pathname == '/' ||
        window.location.pathname == '/forgot-password' ||
        window.location.pathname == '/login'
      ) {
        this.showHeader = false;
      } else {
        this.showHeader = true;
      }
    });
  }
}
